import React from "react";
import {
  StyledPagination,
  StyledPageText,
  StyledPageTextWrapper,
} from "./styled";
import PageInput from "../PageInput";
import PageRow from "../PageRow";
import { PaginationProps } from "../../types/PaginationProps";

const Pagination = ({
  name,
  onChangePageIndex,
  pageIndex,
  pages,
  onChangePageRow,
  activePage,
  marginRight,
}: PaginationProps) => {
  return (
    <StyledPagination marginright={marginRight}>
      <StyledPageTextWrapper>
        <StyledPageText>{name}</StyledPageText>
        <PageInput
          onChangePageIndex={onChangePageIndex}
          pageIndex={pageIndex}
        />
      </StyledPageTextWrapper>
      <PageRow
        pages={pages}
        onChangePageRow={onChangePageRow}
        activePage={activePage}
      />
    </StyledPagination>
  );
};

export default Pagination;
